var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirportSlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.665,10.718L12.335,10.718L12.274,10.143L15.165,10.143L23.726,21.347L13.471,21.326L13.194,18.737L10.806,18.737L10.529,21.326L0.274,21.347L8.835,10.143L11.726,10.143L11.665,10.718ZM11.285,14.266L10.923,17.644L13.077,17.644L12.715,14.266L11.285,14.266ZM11.616,11.172L11.371,13.457L12.629,13.457L12.384,11.172L11.616,11.172Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.403,3.263L15.298,3.263L15.298,3.801L12.71,4.147C13.066,4.296 13.367,4.554 13.573,4.881L22.274,4.881L22.274,5.46L18.614,5.728C18.795,5.891 18.908,6.125 18.908,6.385C18.908,6.877 18.501,7.277 18,7.277C17.499,7.277 17.092,6.877 17.092,6.385C17.092,6.173 17.168,5.978 17.293,5.825L13.856,6.076C13.768,7.038 12.97,7.792 12,7.792C11.029,7.792 10.23,7.036 10.143,6.072L6.705,5.822C6.832,5.976 6.908,6.172 6.908,6.385C6.908,6.877 6.501,7.277 6,7.277C5.499,7.277 5.092,6.877 5.092,6.385C5.092,6.124 5.206,5.89 5.387,5.726L1.726,5.46L1.726,4.881L10.427,4.881C10.633,4.555 10.933,4.296 11.29,4.147L8.739,3.801L8.739,3.263L11.606,3.263L11.762,0.804L12.26,0.804L12.403,3.263Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportSlot);
export default __webpack_public_path__ + "static/media/airport-slot.df5134a5.svg";
export { ForwardRef as ReactComponent };